// extracted by mini-css-extract-plugin
export default {"bucketSelector":"os81H"};